module.exports = __webpack_public_path__ + "img/btnLOGO.81392598.png";